(function () {
  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function initSlider(section) {
    var slider = section.querySelector('[data-et-bundle-usp-slider]');

    if (!slider || slider.dataset.initialized === 'true' || typeof Swiper === 'undefined') {
      return;
    }

    slider.dataset.initialized = 'true';

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      pagination: {
        el: slider.querySelector('.et-bundle-usp__pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 24,
          allowTouchMove: false
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.et-bundle-usp').forEach(initSlider);
  }

  function boot() {
    whenSwiperReady(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.et-bundle-usp') || event.target;

    if (section.classList.contains('et-bundle-usp')) {
      section.querySelectorAll('[data-et-bundle-usp-slider]').forEach(function (slider) {
        slider.dataset.initialized = 'false';
      });
      whenSwiperReady(function () {
        initSlider(section);
      });
    }
  });
})();
